<template>
  <v-container class="d-flex justify-center flex-column">
   
    
    <v-main v-if="isCurrentTabDos">
      <!-- Subir archivos  -->
      <v-row v-if="consultaNueva.length <= 0">
        <!-- Sección de subida de archivos  -->
        <v-row class="d-flex justify-center">
          <v-col cols="12">
            <v-card-title class="font-weight-bold display-1">Imágenes</v-card-title>
            <v-card-subtitle class="primary--text">
              Sube las imágenes que desees
            </v-card-subtitle>
          </v-col>
          <section class="pa-16 border-dashed-thin rounded-xl">
            <v-col cols="12" class="d-flex justify-center">
              <v-icon large>mdi-file-upload-outline</v-icon>
            </v-col>
            <v-file-input ref="file" label="Haz clic para seleccionar" outlined counter multiple show-size
              prepend-icon="mdi-image" truncate-length="50" accept="image/*" @change="onFileChange">
              <template v-slot:selection="{ text }">
                <v-chip class="ma-2 pa-2" small close>
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            Archivos soportados: WEBP, SVG, JPG.
          </section>
        </v-row>

        <!-- Sección de imágenes subidas -->
        <v-row class="d-flex justify-center">
          <v-col cols="12">
            <v-card-title>
              <v-icon left>mdi-image</v-icon>
              {{ uploadedFiles.length }} de 20 imágenes requeridas.
            </v-card-title>
            <v-card-subtitle>
              Aquí se muestran los archivos que ya se cargaron
            </v-card-subtitle>
          </v-col>
        </v-row>

        <!-- Mostrar imágenes subidas -->
        <v-row class="d-flex justify-space-around">
          <v-col cols="12" md="4" v-for="(file, index) in uploadedFiles" :key="index">
            <v-row class="d-flex">
              <v-card class="d-flex flex-row flex-md-column" max-width="374">
                <v-img contain class="fill-height ma-0" aspect-ratio="16/9" height="250" :src="file.preview"></v-img>

                <v-col>
                  <v-card-title class="body-1 font-weight-bold">
                    {{ file.name }}
                  </v-card-title>
                  <v-card-subtitle>
                    <v-list>
                      <v-list-item-content>
                        <v-list-item-title>
                          Tamaño: {{ (file.size / 1024).toFixed(2) }} KB
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          Dimensiones reales: {{ file.width }} x
                          {{ file.height }} px
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="!file.dimensionsValid" class="red--text">
                          Las dimensiones no son las esperadas.
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list>
                  </v-card-subtitle>
                </v-col>
                <v-card-actions class="d-flex justify-end">
                  <v-btn color="error" outlined rounded :icon="$vuetify.breakpoint.smAndDown"
                    @click="removeFile(index)">
                    <v-text v-if="$vuetify.breakpoint.mdAndUp">Eliminar</v-text>
                    <v-icon small :right="$vuetify.breakpoint.mdAndUp">mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-row>
          </v-col>
        </v-row>





        <!-- Lista de imágenes verificadas -->
        <v-row>
          <v-col cols="12">
            <v-card-title class="font-weight-bold">
              Lista de imágenes verificadas
            </v-card-title>
            <v-list class="d-flex flex-wrap">
              <v-list-item v-for="(image, index) in expectedImages" :key="index" class="w-50">
                <v-list-item-content>
                  <v-list-item-title>{{ image.name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    Dimensiones esperadas: {{ image.width }} {{ image.height }} px
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon color="green" v-if="image.uploaded">mdi-check-circle</v-icon>
                  <v-icon color="grey" v-else>mdi-checkbox-blank-circle-outline</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-row>

      <!-- Servidor  -->
      <v-row v-if="consultaNueva.length >= 1">
        <!-- Sección de remplazo de archivos -->
        <v-card-title class="font-weight-bold display-1">Imágenes</v-card-title>
        <v-row v-if="consultaNueva.length < 20" class="d-flex justify-center">
          <v-col cols="12">
            <v-card-title class="font-weight-bold display-1">Imágenes</v-card-title>
            <v-card-subtitle class="primary--text">
              Sube las imágenes que desees remplazar
            </v-card-subtitle>
          </v-col>
          <section class="pa-16 border-dashed-thin rounded-xl">
            <v-col cols="12" class="d-flex justify-center">
              <v-icon large>mdi-file-upload-outline</v-icon>
            </v-col>
            <v-file-input ref="file" label="Haz clic para seleccionar" outlined counter multiple show-size
              prepend-icon="mdi-image" truncate-length="50" accept="image/*" @change="onServeChange">
              <template v-slot:selection="{ text }">
                <v-chip class="ma-2 pa-2" small close>
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            Archivos soportados: WEBP, SVG, JPG.
          </section>
        </v-row>

        <!-- Mostrar imágenes subidas -->
        <v-row class="d-flex justify-space-around">
          <v-col cols="12" md="4" v-for="file in consultaNueva" :key="file.id">
            <v-row class="d-flex">
              <v-col>
                <v-card class="d-flex flex-row flex-md-column" max-width="374">
                  <v-img contain class="fill-height ma-0" aspect-ratio="16/9" height="250" :src="file.url"
                    :alt="file.nombre"></v-img>

                  <v-col>
                    <v-card-title class="body-1 font-weight-bold">
                      {{ file.nombre }}
                    </v-card-title>
                    <v-card-subtitle>
                      <v-list>
                        <v-list-item-content>

                        </v-list-item-content>
                      </v-list>
                    </v-card-subtitle>
                  </v-col>
                  <!-- Actions -->
                  <v-card-actions class="d-flex justify-end">
                    <v-btn color="error" outlined rounded :icon="$vuetify.breakpoint.smAndDown"
                      @click="removeFileServe(file.id)">
                      <v-text v-if="$vuetify.breakpoint.mdAndUp">Eliminar</v-text>
                      <v-icon small :right="$vuetify.breakpoint.mdAndUp">mdi-delete</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>


        <!-- Lista de imágenes retornadas desde el servidor -->
        <v-row>
          <v-col cols="12">
            <v-card-title class="font-weight-bold">
              Lista de imágenes en el servidor
            </v-card-title>
            <v-card-subtitle>{{ consultaNueva.length }} de 20 imágenes en el servidor</v-card-subtitle>
            <v-list class="d-flex flex-wrap">
              <v-list-item v-for="image in consultaNueva" :key="image.id" class="w-50 my-auto">
                <v-list-item-content>
                  <v-list-item-avatar>
                    <v-img contain :src="image.url"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-title>{{ image.nombre }}</v-list-item-title>
                </v-list-item-content>


                <v-list-item-action class="d-flex flex-row  " v-if="image.url">

                  <v-btn fab color="green" small class="mr-4">
                    <v-icon small color="white">mdi-check-bold</v-icon>
                  </v-btn>
                  <!-- <v-btn color="error" outlined rounded 
                  :large="$vuetify.breakpoint.mdAndUp"
                    :small="$vuetify.breakpoint.smAndDown" :fab="$vuetify.breakpoint.smAndDown"
                    :icon="$vuetify.breakpoint.smAndDown">
                    <v-text v-if="$vuetify.breakpoint.mdAndUp">Eliminar</v-text>
                    <v-icon :small="$vuetify.breakpoint.smAndDown"
                      :right="$vuetify.breakpoint.mdAndUp">mdi-delete</v-icon>
                  </v-btn> -->
                </v-list-item-action>
                <v-list-item-action v-else>
                  <v-icon color="grey">mdi-checkbox-blank-circle-outline</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>


      </v-row>

      <!-- Botón para confirmar y subir   -->
      <v-card-actions class="d-flex justify-end mt-8">

        <v-btn large class="primary px-8" rounded @click="submitFiles" v-if="consultaNueva.length <= 0"
          :disabled="isUploadDisabled">
          Subir Imagenes
        </v-btn>

        <v-btn v-if="consultaNueva.length >= 1" large class="primary px-8" rounded
          :disabled="consultaNueva.length >= 20">
          Remplazar Imagenes
        </v-btn>
      </v-card-actions>

      <v-snackbar v-model="snackbar" :timeout="snackbarTimeout" color="error" top>
        {{ snackbarMessage }}
        <v-btn color="white" text @click="snackbar = false">Cerrar</v-btn>

      </v-snackbar>
    </v-main>

    <!-- Tab resumen -->

    <!-- Mostrar imágenes subidas -->
    <v-row v-if="isCurrentTabDoce" class="d-flex justify-space-around">
      <v-col cols="12" md="4" v-for="file in consultaNueva" :key="file.id">
        <v-row class="d-flex">
          <v-col>
            <v-card class="d-flex flex-row flex-md-column" max-width="374">
              <v-img contain class="fill-height ma-0" aspect-ratio="16/9" height="250" :src="file.url"></v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { mapActions } from 'vuex'; // Importa mapActions
import { configApi } from '../../api/configApi';
import { headers } from '../../api/headers';
export default {
  props: {
    isCurrentTabDos: {
      type: Boolean,
      default: false
    },
    isCurrentTabDoce: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uploadedFiles: [],
      expectedImages: [], // Nueva propiedad para almacenar las imágenes esperadas
      snackbar: false,
      snackbarMessage: '',
      snackbarTimeout: 6000,
      imagenesevento: [],
      images: [],
      name: null,
      consultaNueva: [],
    };
  },

  methods: {
    ...mapActions('solicitudevento', [
      'guardarImagenesEventoAll',
      'eliminarImagenEventoAll',
    ]),
    

    async onFileChange(files) {
      // Validar los archivos antes de procesarlos

      const validationResult = this.validateFiles(files);
      if (validationResult !== true) {
        // Mostrar mensaje de error al usuario
        this.snackbarMessage = validationResult;
        this.snackbar = true;

        // Resetear el input de archivos
        this.$refs.fileInput.value = null;
        return;
      }

      // Si la validación es exitosa, procedemos a procesar los archivos
      const newFiles = await Promise.all(
        Array.from(files).map(async (file) => {

          const sinext = file.name.split('.')

          const preview = URL.createObjectURL(file);

          // Obtener dimensiones de la imagen
          const dimensions = await this.getImageDimensions(file);
          const [expectedWidth, expectedHeight] = this.getExpectedDimensions(
            file.name
          );
          const tolerance = 1; // Tolerancia en píxeles
          const expectedDimensions = this.getExpectedDimensions(file.name); // Array de parejas
          const dimensionsValid = expectedDimensions.some(([w, h]) => {
            return (
              Math.abs(dimensions.width - w) <= tolerance &&
              Math.abs(dimensions.height - h) <= tolerance
            );
          });




          return {
            file,
            name: file.name,
            nombre: sinext[0],
            type: file.type,
            size: file.size,
            selected: false,
            preview,
            width: dimensions.width,
            height: dimensions.height,
            dimensionsValid,
          };
        })
      );

      const validFiles = newFiles.filter((file) => file.dimensionsValid);
      const invalidFiles = newFiles.filter((file) => !file.dimensionsValid);

      // Agregar los archivos válidos a la lista existente
      this.uploadedFiles = [...this.uploadedFiles, ...validFiles];

      // Actualizar el estado de las imágenes esperadas
      this.updateExpectedImages(validFiles);

      if (invalidFiles.length > 0) {
        // Mostrar mensajes de error de manera amigable
        this.snackbarMessage =
          'Algunas imágenes no tienen las dimensiones correctas y no se subirán.';
        this.snackbar = true;
      }

      // Al final del método onFileChange
      this.$refs.fileInput.value = null;
    },
    getImageDimensions(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        if (file.type === 'image/svg+xml') {
          // Procesar SVG: leer como texto
          reader.onload = function (e) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(e.target.result, 'image/svg+xml');
            const svg = doc.querySelector('svg');
            if (svg) {
              let width = svg.getAttribute('width');
              let height = svg.getAttribute('height');
              // Si no se definen width o height, usa el viewBox
              if ((!width || !height) && svg.getAttribute('viewBox')) {
                const viewBox = svg.getAttribute('viewBox').split(' ');
                width = viewBox[2];
                height = viewBox[3];
              }
              width = parseFloat(width) || 0;
              height = parseFloat(height) || 0;
              resolve({ width, height });
            } else {
              // Si no se encontró un <svg> válido, resolver con 0
              resolve({ width: 0, height: 0 });
            }
          };
          reader.onerror = function () {
            resolve({ width: 0, height: 0 });
          };
          reader.readAsText(file);
        } else {
          // Para imágenes rasterizadas (PNG, JPG, etc.)
          reader.onload = function (e) {
            const image = new Image();
            image.onload = function () {
              resolve({ width: image.width, height: image.height });
            };
            image.onerror = function () {
              resolve({ width: 0, height: 0 });
            };
            image.src = e.target.result;
          };
          reader.onerror = function () {
            resolve({ width: 0, height: 0 });
          };
          reader.readAsDataURL(file);
        }
      });
    },

    getExpectedDimensions(fileName) {
      const validNames = {
        miniatura_320: [[320, 240]],
        miniatura_600: [[600, 600]],
        imagen_card_desktop: [[512, 640]],
        imagen_card_mobile: [[320, 480]],
        banner_x1_360: [[720, 1080]],
        banner_x1_600: [[1200, 1728]],
        banner_x1_960: [[1920, 708]],
        banner_x1_1264: [[2528, 932]],
        banner_x1_1440: [[2880, 1280]],
        banner_x1_1880: [[1880, 692]],
        banner_x2_720: [[1440, 2160]],
        banner_x2_1200: [[2400, 3456]],
        banner_x2_1920: [[3840, 1416]],
        banner_x2_2528: [[5056, 1864]],
        banner_x2_2880: [[5760, 2560]],
        precios_mobile: [[480, 720]],
        precios_desktop: [[720, 480]],
        mapa_mobile: [[480, 720], [960, 1440]], // Dos opciones para mapa_mobile
        mapa_desktop: [[1280, 720]],
        DisenoBoleta: [[794, 1124]],
      };
      const fileNameWithoutExtension = fileName
        .split('.')
        .slice(0, -1)
        .join('.');
      return validNames[fileNameWithoutExtension] || [[0, 0]];
    },

    getExpectedImageList() {
      // Crear una lista de imágenes esperadas con su estado inicial
      const validNames = {
        miniatura_320: [[320, 240]],
        miniatura_600: [[600, 600]],
        imagen_card_desktop: [[512, 640]],
        imagen_card_mobile: [[320, 480]],
        banner_x1_360: [[720, 1080]],
        banner_x1_600: [[1200, 1728]],
        banner_x1_960: [[1920, 708]],
        banner_x1_1264: [[2528, 932]],
        banner_x1_1440: [[2880, 1280]],
        banner_x1_1880: [[1880, 692]],
        banner_x2_720: [[1440, 2160]],
        banner_x2_1200: [[2400, 3456]],
        banner_x2_1920: [[3840, 1416]],
        banner_x2_2528: [[5056, 1864]],
        banner_x2_2880: [[5760, 2560]],
        precios_mobile: [[480, 720]],
        precios_desktop: [[720, 480]],
        mapa_mobile: [[480, 720], [960, 1440]], // Dos opciones para mapa_mobile
        mapa_desktop: [[1280, 720]],
        DisenoBoleta: [[794, 1124]],
      };
      return Object.keys(validNames).map((name) => ({
        name,
        width: validNames[name][0],
        height: validNames[name][1],
        uploaded: false, // Indica si la imagen ha sido subida
      }));
    },
    updateExpectedImages(uploadedFiles) {
      // Marcar las imágenes que ya han sido subidas
      uploadedFiles.forEach((file) => {
        const fileNameWithoutExtension = file.name
          .split('.')
          .slice(0, -1)
          .join('.');
        const image = this.expectedImages.find(
          (img) => img.name === fileNameWithoutExtension
        );
        if (image) {
          image.uploaded = true;
        }
      });
    },
    validateFiles: function (files) {

      if (files.length > 20) {
        return 'Solo puedes subir hasta 20 imágenes.';
      }
      const validNames = [
        'miniatura_320',
        'miniatura_600',
        'imagen_card_desktop',
        'imagen_card_mobile',
        'banner_x1_360',
        'banner_x1_600',
        'banner_x1_960',
        'banner_x1_1264',
        'banner_x1_1440',
        'banner_x1_1880',
        'banner_x2_720',
        'banner_x2_1200',
        'banner_x2_1920',
        'banner_x2_2528',
        'banner_x2_2880',
        'precios_mobile',
        'precios_desktop',
        'mapa_mobile',
        'mapa_desktop',
        'DisenoBoleta',
      ];

      for (let file of files) {
        const fileNameWithoutExtension = file.name
          .split('.')
          .slice(0, -1)
          .join('.');

        // Verificar si el archivo ya ha sido agregado
        const alreadyExists = this.uploadedFiles.some((uploadedFile) => {
          const uploadedFileNameWithoutExtension = uploadedFile.name
            .split('.')
            .slice(0, -1)
            .join('.');
          return (
            uploadedFileNameWithoutExtension === fileNameWithoutExtension
          );
        });
        if (alreadyExists) {
          return `El archivo ${file.name} ya ha sido agregado. No puedes subir archivos duplicados.`;
        }

        if (!validNames.includes(fileNameWithoutExtension)) {
          return `El archivo ${file.name
            } debe tener uno de los siguientes nombres: ${validNames.join(
              ', '
            )}.`;
        }
        if (!['image/webp', 'image/jpeg', 'image/svg+xml',].includes(file.type)) {
          return `El archivo ${file.name} no es un formato permitido. Solo se aceptan WEBP,JPG y SVG.`;
        }
        const maxSize = 2 * 1024 * 1024;
        if (file.size > maxSize) {
          return `El archivo ${file.name} supera el tamaño máximo de 2MB.`;
        }
      }
      return true;
    },

    removeFile(index) {
      // Llamar a la acción del store
      this.eliminarImagenEventoAll(index);

      // También eliminar del arreglo local y actualizar el estado
      const removedFile = this.uploadedFiles.splice(index, 1)[0];
      URL.revokeObjectURL(removedFile.preview);

      // Actualizar el estado de las imágenes esperadas
      const fileNameWithoutExtension = removedFile.name
        .split('.')
        .slice(0, -1)
        .join('.');
      const image = this.expectedImages.find(
        (img) => img.name === fileNameWithoutExtension
      );
      if (image) {
        image.uploaded = false;
      }
    },
    async submitFiles() {
      if (this.uploadedFiles.length !== 20) {
        this.snackbarMessage = 'Debes subir exactamente 20 imágenes.';
        this.snackbar = true;
        return;
      }
      const validFiles = this.uploadedFiles.filter(
        (file) => file.dimensionsValid
      );
      if (validFiles.length !== this.uploadedFiles.length) {
        alert('Algunas imágenes no tienen las dimensiones correctas.');
        return;
      }

      try {

        // Extraemos solo el objeto File de cada elemento
        const filesToSend = validFiles.map(item => item.file);

        for (const file of filesToSend) {
          await this.$store.dispatch('imagen/newImagen64', {
            imagen: file,
            metodo: 'Nuevo',
            nombre: file.name
          });
        }

        // Limpiar los archivos si es necesario
        // this.uploadedFiles = [];
      } catch (error) {
        console.error('Error al procesar las imágenes:', error);
        alert('Error al procesar las imágenes');
      }
    },
    async removeFileServe(fileId) {
      console.log('eliminar lamt',fileId)

      axios.get(`${configApi.apiUrl}eliminar_imagen/`+fileId, { headers: headers })
      .then((response) => {
        console.log('me devuelve del backend',response);
      })

    },
    async onServeChange(){
      console.log('remplazar imagenes')
    }
  },
  computed: {
    isUploadDisabled() {
      return this.uploadedFiles.length !== 20;
    },
    isFullImages() {
      return this.consultaNueva.length;
    }
  },
  watch: {
    isFullImages(newVal) {
      console.log("Cantidad de imágenes (isFullImages):", newVal);
      this.$emit("updateImageCount", newVal);
    }
  },
  created() {
   
    this.expectedImages = this.getExpectedImageList();

 
    axios.get(`${configApi.apiUrl}buscarimageneseventoprevio`, { headers: headers })
      .then((response) => {
        
        this.consultaNueva = response.data && response.data.data ? response.data.data : [];
      })

  },  
}
</script>
<style scoped>
.border-dashed-thin {
  border: 1px dashed #cac5cb;
}

.mx-2 {
  margin-left: 8px;
  margin-right: 8px;
}
</style>
